<template>
    <div class="alipay-content">
        <van-cell-group>
            <template #title>
                <div class="title">
                    <div class="title-box">
                        <span style="color: black;">银行卡信息</span>
                        <span style="margin-left: 8px; font-size: 11px; color:red">24小时内到账</span>
                    </div>
                    <div class="title-box">
                        <van-radio-group v-model="radioValue">
                            <van-radio :name="1" @click="setDefault">设为默认</van-radio>
                        </van-radio-group>
                    </div>
                </div>
            </template>
            <van-field v-model="bank.bankName" label="银行名称" placeholder="例：中国建设银行" required :error-message="bankNameErrMsg"
                @focus="inputFocus" />            
            <van-field v-model="bank.name" label="姓名" placeholder="例：张三" required :error-message="nameErrMsg"
                    @focus="inputFocus" />
            <van-field v-model="bank.account" label="银行卡号" placeholder="请输入银行卡号（不支持信用卡）" required
                :error-message="accountErrMsg" @focus="inputFocus" @input="handleAccountInput"/>
        </van-cell-group>
        <div class="form-btn">
            <van-button block type="warning" @click="saveHandler">保 存</van-button>

            <van-button class="delete-btn" block type="danger" :disabled="deleteBtnDisabled" @click="deleteHandler">删 除</van-button>
        </div>
    </div>
</template>
<script>
import { Toast } from 'vant';
import { createBankAccountApi, updateBankAccountApi, deleteAccountApi } from 'api/submit'

export default {
    data() {
        return {
            mode: 0,
            bankCardNoReg: /^\d{13,19}$/,
            emailReg: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            radioValue: 0,
            isDefault: false,
            bank: {
                id: '',
                bankName: '',
                name: '',
                account: ''
            },
            bankNameErrMsg: '',
            nameErrMsg: '',
            accountErrMsg: '',
            deleteBtnDisabled: false
        }
    },
    mounted() {
        const mode = this.$route.query.mode
        if (mode === 1) {
            this.mode = 1
            this.bank.id = this.$route.query.bankId
            this.bank.bankName = this.$route.query.bankName
            this.bank.name = this.$route.query.accountHolder
            this.bank.account = this.$route.query.bankAccount
            this.radioValue = this.$route.query.isDefault
        }

    },
    methods: {
        setDefault() {
            if (!this.isDefault) {
                this.isDefault = true
            } else {
                this.radioValue = 0
                this.isDefault = false
            }
        },
        saveHandler() {
            if (this.mode === 0) {
                this.createBankAccount()
            } else {
                this.updateBankAccount()
            }
        },
        createBankAccount() {
            if (!this.validator()) return

            let data = { ...this.bank, isDefault: this.radioValue }

            createBankAccountApi(data).then(({ status, message }) => {
                if (status === 200) {
                    Toast('保存成功')
                    this.$back(-1)
                }
                else if (status === 400) {
                    this.$toast(message)
                } else {
                    this.$toast('网络异常，请稍后再试')
                }
            })
        },
        updateBankAccount() {
            if (!this.validator()) return
            let data = { ...this.bank, isDefault: this.radioValue }
            updateBankAccountApi(data).then(({ status, message}) => {
                if (status === 200) {
                    Toast('保存成功')
                    this.$back(-1)
                }
                else if (status === 400) {
                    this.$toast(message)
                } else {
                    this.$toast('网络异常，请稍后再试')
                }
            })
        },
        deleteHandler() {
            this.$dialog.confirm({
                title: '温馨提示',
                message: '确定删除该账号吗？',
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                theme: 'round-button'
            }).then(() => {
                if (this.bank.id === '') {
                    this.$toast('删除失败[CODE: -1]')
                    return
                }
                this.deleteBtnDisabled = true
                deleteAccountApi(this.bank.id).then(({ status, message }) => {
                    this.deleteBtnDisabled = false
                    if (status === 200) {
                        Toast('删除成功')
                        this.$back(-1)
                    } else if (status === 400) {
                        this.$toast(message)
                    } else {
                        this.$toast('网络异常，请稍后再试')
                    }
                }).catch(() => {
                    this.deleteBtnDisabled = false
                })
            }).catch(() => {
                // on cancel
            })
        },
        validator() {
            if (this.bank.bankName.length === 0) {
                this.bankNameErrMsg = '请输入银行名称'
                return false
            }
            if (this.bank.name.length === 0) {
                this.nameErrMsg = '请输入姓名'
                return false
            }            
            if (this.bank.account.length === 0) {
                this.accountErrMsg = '请输入账号'
                return false
            }
            if (!this.bankCardNoReg.test(this.bank.account)) {
                this.accountErrMsg = '银行卡号格式错误'
                return false
            }
            return true
        },
        inputFocus() {
            this.nameErrMsg = ''
            this.accountErrMsg = ''
        },
        handleAccountInput(val) {
            this.bank.account = val.replace(/\s+/g, ''); // 去除所有空白
        }
    }
}
</script>
<style lang="css" scoped>
.alipay-content {
    padding: 10px;
}

.title {
    display: flex;
    justify-content: space-between;
}

.title-box {
    display: inline-block;
}

.form-btn {
    margin-top: 8px;
}
.delete-btn {
    margin: 15px 0;
}
</style>